import React from 'react'
import { Link } from 'react-router-dom'
import { LoginRoute } from 'resources/routes'

const CancelButton = ({
  text = 'Cancel',
  route = LoginRoute,
  disabled = false,
  testKey,
  className = 'btn btn--main-cancel',
}) => {
  return (
    <Link
      id={`ext--${testKey}`}
      data-test-key={testKey}
      className={className}
      disabled={disabled}
      to={route}
    >
      {text}
    </Link>
  )
}

export default CancelButton
